import { Navigate, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth";
import { AlertProvider } from "./providers/AlertProvider";
import Providers from "@hydrologiq/shared/providers/Providers";
import {
  RouteProvider,
  Section,
} from "@hydrologiq/shared/providers/RouteProvider";
import ScrollToTop from "@hydrologiq/shared/ScrollToTop";
import AlertsPaginated from "./views/AlertsPaginated";
import AlertDetail from "./views/AlertDetail";
import AlertsMap from "./views/AlertsMap";
import AlertsKanban from "./views/AlertsKanban";
import store from "./state/store";
import AlertsSelection from "./components/selection/AlertsSelection";

function Routing(props: {
  basePath?: string;
  user?: DashboardUser;
  container?: React.RefObject<HTMLElement>;
}) {
  const sectionPath = "alerts";
  const { basePath = sectionPath, container } = props;

  return (
    <Provider store={store}>
      <ScrollToTop />
      <Routes>
        {!basePath && (
          <Route path={sectionPath} element={<Navigate to={"/"} />} />
        )}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.ALERTS}>
              <Providers container={container}>
                <AlertProvider>
                  <AlertsSelection />
                </AlertProvider>
              </Providers>
            </RouteProvider>
          }
        >
          <Route index element={<AlertsMap />} />
          <Route path="list" element={<AlertsPaginated />} />
          <Route path="board" element={<AlertsKanban />} />
          <Route path=":alertId" element={<AlertDetail />} />
        </Route>
      </Routes>
    </Provider>
  );
}

export default Routing;
